import { useEffect, useState } from 'react';
import { Validation } from '@/models';

function useValidation(value: string | boolean, validations: Validation[]) {
  const [requiredError, setRequiredError] = useState('');
  const [minLengthError, setMinLengthError] = useState('');
  const [maxLengthError, setMaxLengthError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [equalError, setEqualError] = useState('');
  const [regexError, setRegexError] = useState('');
  const [gtError, setGtError] = useState('');
  const [ltError, setLtError] = useState('');
  const [cbError, setCbError] = useState('');

  useEffect(() => {
    validations.forEach((validation: Validation) => {
      switch (validation.name) {
        case 'required': {
          setRequiredError(
            !value && validation.value ? validation.message : '',
          );
          break;
        }
        case 'minLength': {
          setMinLengthError(
            (value as string).length < (validation.value as number)
              ? validation.message
              : '',
          );
          break;
        }
        case 'maxLength': {
          setMaxLengthError(
            (value as string).length > (validation.value as number)
              ? validation.message
              : '',
          );
          break;
        }
        case 'email': {
          if (value === '') {
            setEmailError('');
          } else {
            setEmailError(
              (value as string).toLowerCase().match(validation.value as RegExp)
                ? ''
                : validation.message,
            );
          }
          break;
        }
        case 'equal': {
          if (value === '') {
            setEqualError('');
          } else {
            setEqualError(
              (value as string) === (validation.value as string)
                ? ''
                : validation.message,
            );
          }
          break;
        }
        case 'regex': {
          if (value === '' || value === undefined) {
            setRegexError('');
          } else {
            setRegexError(
              value.toString().match(validation.value as RegExp)
                ? ''
                : validation.message,
            );
          }
          break;
        }
        case 'gt': {
          if (value === '') {
            setGtError('');
          } else {
            setGtError(
              Number(value) > (validation.value as number)
                ? ''
                : validation.message,
            );
          }
          break;
        }
        case 'lt': {
          if (value === '') {
            setLtError('');
          } else {
            setLtError(
              Number(value) <= (validation.value as number)
                ? ''
                : validation.message,
            );
          }
          break;
        }
        case 'cb': {
          if (value === '') {
            setCbError('');
          } else if (typeof validation.value === 'function') {
            setCbError(validation.value(value) ? '' : validation.message);
          }
          break;
        }
        default: {
          break;
        }
      }
    });
  }, [value, validations]);

  return {
    requiredError,
    minLengthError,
    maxLengthError,
    emailError,
    equalError,
    regexError,
    gtError,
    ltError,
    cbError,
  };
}

export default useValidation;
